// Thin fetch helpers for the static R2-backed JSON.
//
// Same-origin by default (Cloudflare Pages routes /manifest.json and
// /articles/<id>.json to the R2 bucket). VITE_R2_BASE_URL overrides for
// local dev pointing at a staging endpoint.

const BASE = (import.meta.env.VITE_R2_BASE_URL ?? "").replace(/\/$/, "");

// The engagement + identity endpoints are served by the Cloudflare Worker,
// which is same-origin in production (it owns the /api/* routes). For local
// dev against a `wrangler dev` instance, VITE_API_BASE_URL points elsewhere.
const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, "");

export const MANIFEST_PATH = `${BASE}/manifest.json`;
export const VERSION_PATH = `${BASE}/version.json`;

export function articleDetailPath(id: number): string {
  return `${BASE}/articles/${id}.json`;
}

/** Resolve an `/api/...` worker path against the (optional) API base. */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    throw new Error(`fetch ${url} -> ${res.status} ${res.statusText}`);
  }
  return (await res.json()) as T;
}
